import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {connect} from 'react-redux';
import reduxRouteChanged from 'services/reduxRouteChanged.js';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import styles from './email-verification.scss';
import {replace} from "react-router-redux";
import {verifyEmailByTokenAction} from "../../../auth/authWithOtp/redux2";
import LoadingBlocking from "../../../components/loading/LoadingBlocking";
import Layout from "../../../auth/Layout";
import contactUsUrl from "../../../utils/url/contactUsUrl";

@injectIntl
@connect(
  (state) => ({
    isLoading: state.authRoot.updateEmail.isLoadingVerifyEmail,
    isSuccess: state.authRoot.updateEmail.isVerifyEmailSuccess,
    isFail: state.authRoot.updateEmail.isVerifyEmailFail,
  }),
  dispatch => ({
    redirect: (path) => dispatch(replace(path)),
    verifyEmail: (token) => dispatch(verifyEmailByTokenAction(token)),
  })
)

@CSSModules(styles)
class EmailVerification extends React.Component {
  static propTypes = {
    intl: intlShape,
    redirect: PropTypes.func.isRequired,
    verifyEmail: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    isSuccess: PropTypes.bool,
    isFail: PropTypes.bool,
  };



  constructor(props) {
    super(props);
    this.state = {
      isUrlLoading: true,
      isUrlError: false,
    };
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const t = queryParams.get('t'); // Get the 't' query parameter
    if (!t) {
      this.setState(state => {
        return {
          ...state,
          isUrlError: true,
          isUrlLoading: false,
        };
      });
    } else {
      this.setState(state => {
        return {
          ...state,
          isUrlError: false,
          isUrlLoading: false,
        };
      });
      this.props.verifyEmail(t);
    }
  }

  render() {
    const {intl: {formatMessage}} = this.props;
    const contactUsLink = (
      <a href={contactUsUrl()} target="_blank" >
        {formatMessage({ id: "common.link.contactUs.text" })}
      </a>
    );

    return (
      <Layout>
        <div styleName="button">
          {(this.state.isUrlLoading || this.props.isLoading) && <LoadingBlocking/>}

          {(this.state.isUrlError || this.props.isFail) && <div styleName="title">
            <FormattedMessage
              id="auth.updateEmail.fail.msg"
              values={{ contactUsLink }}
            />
          </div>}


          {this.props.isSuccess && <div styleName="title">Your email address has been verified and updated in our records.</div>}
        </div>
      </Layout>
    );
  }
}

function initStore() {}

export default reduxRouteChanged(initStore, EmailVerification);



// WEBPACK FOOTER //
// ./src/containers/auth/email-verification/email-verification.js